import SafetyAnchorPointListResourcePagingResultModel from '../../generated/types/model/resource/SafetyAnchorPointListResourcePagingResultModel';

export default class SafetyAnchorPointListResourcePagingResultViewModel extends SafetyAnchorPointListResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
